import { useState, useEffect } from 'react'
import trackError from '@helpers/trackError'
import { DEV_FLAG_OVERRIDES } from '@lib/flags'

type ABTests = {
  tests: string[]
  testsVariants: Record<string, string>
  testsLoaded: boolean
}

function useABtests() {
  const [abTests, setABTests] = useState<ABTests>({
    tests: [],
    testsVariants: {},
    testsLoaded: false
  })

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      setABTests({
        tests: Object.keys(DEV_FLAG_OVERRIDES),
        testsVariants: DEV_FLAG_OVERRIDES,
        testsLoaded: true
      })
      return
    }

    const awaitPostHog = async () => {
      await window.postHogAsyncLoader
      window.posthog?.onFeatureFlags((flags, flagVariants) => {
        setTimeout(() => {
          Object.entries(flagVariants).forEach(([flag, variant]) => {
            window.posthog?.capture('$feature_flag_called', {
              $feature_flag: flag,
              $feature_flag_response: variant
            })
          })
        }, 0)
        const tests = {
          tests: flags,
          testsVariants: flagVariants,
          testsLoaded: true
        }
        setABTests(tests)
      })
    }
    try {
      awaitPostHog()
    } catch (error) {
      trackError(new Error('Failed to get PostHog feature flags'))
    }
  }, [])

  return abTests
}

export default useABtests
